// Small wrapper for session storage
import { CaptureException } from 'Douleutaras/providers/CaptureException';

export const localStorage = () => {
  if (typeof window === 'undefined') {
    return { get: () => undefined, set: () => undefined };
  }
  const storage = window.localStorage;

  return {
    get: (key: string) => {
      try {
        return JSON.parse(storage.getItem(key));
      } catch (e) {
        CaptureException(e);
      }
    },
    // tslint:disable-next-line:no-any
    set: (key: string, value: any): void => storage.setItem(key, JSON.stringify(value))
  };
};

export default localStorage;
